// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.signing.LeasingUserSigningWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  LeasingUserSigningWebApiHandler_markAsSigned,
  LeasingUserSigningWebApiHandler_whoHasSigned,
  LeasingUserSigningWebApiHandler_whoHasSigned_Path,
} from '@zg-rentals/ts-leasing-client';

import type {
  LeaseArtifactType,
  MarkAsSignedRequestDto,
  WhoHasSignedWebApiResponseDto,
} from '@zg-rentals/ts-leasing-client';

interface WhoHasSignedParams {
  leaseArtifactId: number;
  leaseArtifactType: LeaseArtifactType;
}

export interface LeasingUserSigningWebApiHandler_markAsSigned_Args {
  postData: MarkAsSignedRequestDto;
}

export type LeasingUserSigningWebApiHandler_markAsSigned_Options = UseMutationOptions<
  void,
  unknown,
  LeasingUserSigningWebApiHandler_markAsSigned_Args
>;

/**
 * marks the lease as signed for user
 */
export const useLeasingUserSigningWebApiHandler_markAsSigned = ({
  httpClient,
  ...options
}: Omit<LeasingUserSigningWebApiHandler_markAsSigned_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: LeasingUserSigningWebApiHandler_markAsSigned_Args) =>
      LeasingUserSigningWebApiHandler_markAsSigned(args.postData, httpClient),
  });
};

export type LeasingUserSigningWebApiHandler_whoHasSigned_Options = UseQueryOptions<
  WhoHasSignedWebApiResponseDto,
  unknown,
  WhoHasSignedWebApiResponseDto,
  readonly [string, WhoHasSignedParams]
>;

const LeasingUserSigningWebApiHandler_whoHasSigned_GetKey = (getParams: WhoHasSignedParams) =>
  [LeasingUserSigningWebApiHandler_whoHasSigned_Path, getParams] as const;

export const LeasingUserSigningWebApiHandler_whoHasSigned_queryOptions = (
  getParams: WhoHasSignedParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: LeasingUserSigningWebApiHandler_whoHasSigned_GetKey(getParams),
    queryFn: () => LeasingUserSigningWebApiHandler_whoHasSigned(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * get list of users for signing
 */
export const useLeasingUserSigningWebApiHandler_whoHasSigned = (
  getParams: WhoHasSignedParams,
  {
    httpClient,
    ...options
  }: Omit<LeasingUserSigningWebApiHandler_whoHasSigned_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...LeasingUserSigningWebApiHandler_whoHasSigned_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useLeasingUserSigningWebApiHandler_whoHasSigned.getKey = LeasingUserSigningWebApiHandler_whoHasSigned_GetKey;
